import React from "react";
import AntdMenu, {MenuProps} from "antd/lib/menu";
import { withError} from '@fishx/tracker';

const Item = AntdMenu.Item;
const SubMenu = AntdMenu.SubMenu;
const ItemGroup = AntdMenu.ItemGroup;
const Divider = AntdMenu.Divider;

interface FNMenuProps extends React.FC<MenuProps> {
   Item: typeof Item;
   SubMenu: typeof SubMenu;
   ItemGroup: typeof ItemGroup;
   Divider: typeof Divider;
}
export const Menu: FNMenuProps = (props) => {
  return <AntdMenu {...props} />;
}
Menu.Item = Item;
Menu.SubMenu = SubMenu;
Menu.ItemGroup = ItemGroup;
Menu.Divider = Divider;
Menu.displayName = 'Menu';
export default withError(Menu);


// WEBPACK FOOTER //
// ./src/components/menu/index.tsx